import * as ReqType from '../types/ServerRequests';
import { AdresseService } from './AdresseService';
import Axios from 'axios';
import LoginServices from './LoginServices';

/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression des informations du responsable d'un utilisateur
 */
export class ResponsableService {
    private static instance: ResponsableService = new ResponsableService();

    public static getInstance(): ResponsableService {
        return this.instance;
    }

    /**
     * modification et mise à jour des infos d'un responsable
     * @param {Responsable} newResponsable
     * @param {Responsable} oldResponsable
     * @returns {Promise<Responsable>}
     */
    public updateResponsable(
        newResponsable: ReqType.Responsable,
        oldResponsable: ReqType.Responsable
    ): Promise<ReqType.Responsable> {
        const token = LoginServices.getInstance().getUserToken();
        return (Promise.all([
            AdresseService.getInstance().updateAdresse(newResponsable.adresse, oldResponsable.adresse),
        ]).then(
            (array) => {
                var adresse: ReqType.Adresse = array[0];
                var monResponsable = {
                    adresse_id: adresse === null ? null : adresse.id,
                    date_naissance: newResponsable.date_naissance,
                    id: newResponsable.id,
                    lien: newResponsable.lien,
                    nom: newResponsable.nom,
                    prenom: newResponsable.prenom,
                    telephone: newResponsable.telephone,
                };
                return (Axios.put(
                    process.env.REACT_APP_RESPONSABLE_UPDATE_URL! + '&id=' + oldResponsable.id,
                    monResponsable,
                    {
                        headers: { 'X-Access-Token': token },
                    }
                ).then(
                    (response) => {
                        newResponsable.adresse = adresse;
                        return newResponsable;
                    }
                ));
            }
        ));
    }

    /**
     * permet la creation d'un responsable
     * @param {Responsable} newResponsable
     * @returns {Promise<Responsable>}
     */
    public createResponsable(newResponsable: ReqType.Responsable): Promise<ReqType.Responsable> {
        const token = LoginServices.getInstance().getUserToken();
        return (
            Promise.all([
                AdresseService.getInstance().createAdresse(newResponsable.adresse),
            ]).then(
                (array) => {
                    var adresse: ReqType.Adresse = array[0];
                    var monResponsable = {
                        adresse_id: adresse.id,
                        date_naissance: newResponsable.date_naissance,
                        id: newResponsable.id,
                        lien: newResponsable.lien,
                        nom: newResponsable.nom,
                        prenom: newResponsable.prenom,
                        telephone: newResponsable.telephone,
                    };
                    return (Axios.post(
                        process.env.REACT_APP_RESPONSABLE_CREATE_URL!,
                        monResponsable,
                        {
                            headers: { 'X-Access-Token': token },
                        }
                    ).then(
                        (response) => {
                            newResponsable.id = response.data.id;
                            newResponsable.adresse = adresse;
                            return newResponsable;
                        }
                    ));
                }
            )
        );
    }

    /**
     * retourne la valeure par defaut d'un responsable
     * @returns {Responsable}
     */
    public getDefaultResponsable(): ReqType.Responsable {
        const retVal: ReqType.Responsable = {
            adresse: AdresseService.getInstance().getDefaultAdresse(),
            date_naissance: '',
            id: -1,
            lien: '',
            email: '',
            nom: '',
            prenom: '',
            telephone: '',
        };
        return (retVal);
    }

    /**
     * duplique le responsable passer en paramètre
     * @param {Responsable} origin
     * @returns {Responsable}
     */
    public duplicateResponsable(origin: ReqType.Responsable): ReqType.Responsable {
        return (JSON.parse(JSON.stringify(origin)));
    }
}


// WEBPACK FOOTER //
// ./src/services/ResponsableService.tsx